import React from 'react';
import { Row, Col, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { setLocalStorage, getLocalStorage } from '../helpers/custom';
import { CURRENT_USER_TYPE } from '../constants/constants';

import handshake from '../assets/images/handshake.png';
import headset from '../assets/images/headset.png';

const LoginModal = ({ isRegister }) => {
  const [isOpen, setIsOpen] = React.useState(
    Boolean(getLocalStorage(CURRENT_USER_TYPE) ? false : true)
  );

  const selectUser = value => {
    setLocalStorage(CURRENT_USER_TYPE, value);
    window.dispatchEvent(new Event(CURRENT_USER_TYPE));
    setIsOpen(!isOpen);
  };

  return (
    <Modal centered size="lg" fullscreen="sm" isOpen={isOpen} backdrop="static">
      <ModalHeader tag="h2">
        {isRegister ? 'Welcome!!' : 'Welcome back!'}
      </ModalHeader>
      <ModalBody className="text-center">
        <h4 className="my-5">
          {isRegister
            ? 'Before start the registration process, please select one option according to your role.'
            : 'Select an option to continue.'}
        </h4>
        <Row className="d-flex justify-content-evenly">
          <Col className="text-center">
            <button
              className="__login-button my-3"
              onClick={() => selectUser(3)}
            >
              <img src={headset} alt="agents button" />
            </button>
            <h4>Agent</h4>
          </Col>
          <Col className="text-center">
            <button
              className="__login-button my-3"
              onClick={() => selectUser(2)}
            >
              <img src={handshake} alt="clients button" />
            </button>
            <h4>Client</h4>
          </Col>
        </Row>
        {isRegister && (
          <p className="text-danger">
            Remember, you won't be able to switch your account once the register
            process is done.
          </p>
        )}
      </ModalBody>
    </Modal>
  );
};

export default LoginModal;
